import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
//import NavDropdown from 'react-bootstrap/NavDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers,
        faUserMd, 
        faSignOutAlt,
        faExchangeAlt,
        faChartLine } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import Logo from "../Assets/Images/Logo-HRSJ.png";
import {GetTitleHospital} from "../AppConfig";
import Button from 'react-bootstrap/Button';
import {Version} from '../Services/VersionService';

export default function Navbarmenu(props)
{
    var current = 0;
    const url = window.location.href;

    if (url.includes("/procedures"))
    {
        current = 1;
    } else if (url.includes("/direction"))
    {
        current = 2;
    }

    return(
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top" className="vw100">
            <img src={Logo} alt="Logo" className="img_logo_navbar"/>
            <small className="text-muted version">{Version}</small>
            <Button variant="dark" onClick={() => props.SwitchHosp()}>
                <FontAwesomeIcon className="fsp24" icon={faExchangeAlt}/>
            </Button>
            <span className="titlenav">{GetTitleHospital()}</span>
            <span>&nbsp;</span>
            <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                    <NavBarItem 
                        icon={faUsers} 
                        active={current===0} 
                        link="/" 
                        text="Censo"/>
                    <NavBarItem 
                        icon={faUserMd} 
                        active={current===1} 
                        link="/dashboard/procedures" 
                        text="Cirugias"/>
                    <NavBarItem 
                        icon={faChartLine} 
                        active={current===2} 
                        link="/dashboard/direction" 
                        text="Dirección"/>
                </Nav>
                <UserMenu {...props} OnLogout={() => props.OnLogout()}/>
            </Navbar.Collapse>
        </Navbar>
    )
}

function UserMenu(props)
{
    return(
        <Nav>
            <button className="navlink p4" onClick={props.OnLogout}>
            <FontAwesomeIcon icon={faSignOutAlt}/>
            <span>&nbsp;</span>
            Cerrar Sesión
            </button>
        </Nav>
    );
}

function NavBarItem(props)
{
    return(
        <Link to={props.link} className="hover_notd">
            <div className={props.active ? "navlinkactive p6" :"navlink p6"}>
                <FontAwesomeIcon icon={props.icon}/>
                <span>&nbsp;</span>
                {props.text}
            </div>
        </Link>
    );
}